import { IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { Query } from 'utility-ts-orm';
import { IPronounsData, PronounsModel } from '../models/pronouns_model';

export class PronounsQuery implements IQuery {
  private _result: IPronounsData;

  constructor(private ngPronounsModel: PronounsModel) {
    Query.registerQuery(this, ngPronounsModel);
  }

  run(): PronounsQuery {
    this._result = this.ngPronounsModel.read();
    const isPronounsEmpty = this._result.user_id && !this._result.selected_pronouns;
    if (isPronounsEmpty) {
      this._result.selected_pronouns = 'None - do not show';
    }
    return this;
  }

  get result() {
    return this._result;
  }
}

angular.module('data-ng-staff-todos').service('ngPronounsQuery', PronounsQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-priority-feed/src/queries/pronouns_query.ts